<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <div>
                    <app-saved-dashboard-view></app-saved-dashboard-view>
                </div>
                <div *ngFor="let link of [modify_time_users_datasource]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>
                <app-single-select
                    [option]="settingItemDatetimeAggregation.options"
                ></app-single-select>
                <app-toggle
                    [option]="settingsItemCloudsaveNormalizeMetrics.options"
                ></app-toggle>
                <div *ngFor="let link of values(filterDashboardItemLinks)">
                    <!-- TODO Obsłużyć pozostałe typy -->
                    <app-category-filter-dashboard-item
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'CategoryFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                    </app-category-filter-dashboard-item>
                    <!-- Custom logic for this dashboard -->
                    <div
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                                'CategoryFilterDashboardItem' &&
                            link.id ==
                                'mopa.realtime_cloudsave_stats.filter.activity_hour'
                        "
                        style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                        "
                    >
                        <div>
                            <app-checkbox
                                [option]="
                                    settingRealtimeHoursUpToLatest.options
                                "
                            ></app-checkbox>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                                'CategoryFilterDashboardItem' &&
                            link.id ==
                                'mopa.realtime_cloudsave_stats.filter.activity_weekday'
                        "
                        style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                        "
                    >
                        <div>
                            <app-checkbox
                                [option]="settingRealtimeCurrentWeekday.options"
                            ></app-checkbox>
                        </div>
                    </div>
                    <app-date-picker
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'DateRangeFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                        ></app-date-picker
                    >
                    <app-segment-filter
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'SegmentsFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-segment-filter>
                </div>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <div class="am-dash-legend-card">
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="24">
                    <app-common-legend></app-common-legend>
                </div>
            </div>
        </div>
        <div class="main-container">
            <div class="grid-container">
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="6" *ngFor="let link of [commits_cnt]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [commits_users]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- </div>
                <div nz-row [nzGutter]="5"> -->
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [commits_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [commits_users_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="6" *ngFor="let link of [logins_cnt]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [logins_installs]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- </div>
                <div nz-row [nzGutter]="5"> -->
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [logins_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [logins_installs_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>

                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="6" *ngFor="let link of [downloads_cnt]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [downloads_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- </div>
                <div nz-row [nzGutter]="5"> -->
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [downloads_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [downloads_users_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="6" *ngFor="let link of [conflicts_cnt]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [conflicts_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <!-- </div>
                <div nz-row [nzGutter]="5"> -->
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [conflicts_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [conflicts_users_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [incomplete_saves_cnt]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [incomplete_saves_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [incomplete_saves_failure_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="
                            let link of [incomplete_saves_users_failure_rate]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [incomplete_save_dialog_count]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="
                            let link of [incomplete_save_dialog_dst_user_count]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="
                            let link of [
                                cloud_save_double_session_detected_count,
                            ]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="
                            let link of [
                                cloud_save_double_session_detected_dst_user_count,
                            ]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="
                            let link of [
                                cloud_save_purge_incomplete_storage_sum,
                            ]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
